<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>客户档案</el-breadcrumb-item>
            <el-breadcrumb-item>诊断优化</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align: left">
        <el-col :span="24">
          <span class="searchText">创建时间：</span>
          <el-date-picker
            size="small"
            v-model="searchTime"
            type="datetimerange"
            align="right"
            start-placeholder="开始日期"
            range-separator="至"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
          >
          </el-date-picker>
          <el-button
            type="primary"
            size="small"
            plain
            @click="EventChangeSearch"
            style="margin-left: 10px"
            >筛选
          </el-button>
          <!-- <el-button type="primary" size="small" plain @click="EventClearSearch">清空所有筛选项</el-button> -->
          <el-button type="warning" size="small" plain @click="EventAdd"
            >新增</el-button
          >
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-table :data="diagnoseList" style="width: 100%" v-loading="loading">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="账户问题及动作:">
                  <span>{{ scope.row.Approach }}</span>
                </el-form-item>
                <el-form-item label="卡点:">
                  <span>{{ scope.row.Question }}</span>
                </el-form-item>
                <el-form-item label="下步规划:">
                  <span>{{ scope.row.Planning }}</span>
                </el-form-item>
                <el-form-item label="所需支持:">
                  <span>{{ scope.row.Support }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="账户问题及动作" prop="Approach">
          </el-table-column>
          <el-table-column label="下步规划" prop="Planning"> </el-table-column>
          <el-table-column label="卡点" prop="Question"> </el-table-column>
          <el-table-column label="所需支持" prop="Support"> </el-table-column>
          <el-table-column label="创建时间" prop="AddTime"> </el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <el-button
                type="primary"
                plain
                size="small"
                @click="EventChange(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                plain
                size="small"
                @click="delDiagnose(scope.row.Id)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <addDiagnose
        :dialogTitle="dialogTitle"
        :visible="visible"
        :custDiagnose="custDiagnose"
        @close="EventCloseDialog"
        @changeForm="eventChangeForm"
        @submit="EventSubmitForm"
      ></addDiagnose>
    </el-card>
  </div>
</template>

<script>
/**
 * API接口内容
 * */
import { GetCurrentUserInfo } from "@/until/ZeusApiSDK/Logic/HomeLogic";
import {
  getCustomerDetail,
  addCustomerDetail,
  delCustomerDetail
} from "@/until/ZeusApiSDK/Logic/CustomerProfile";
// 组件
import addDiagnose from "@/views/CustomerProfile/components/addDiagnose.vue";
export default {
  components: { addDiagnose },
  data() {
    return {
      customerid: "",
      searchTime: "",
      pageIndex: 1,
      diagnoseList: [],
      loading: false,
      dialogTitle: "",
      visible: false,
      custDiagnose: {},
      Info: GetCurrentUserInfo()
    };
  },
  created() {
    this.customerid = this.$route.params.customerid;
    this.APIgetCustomerDetail();
  },
  methods: {
    // 获取数据
    APIgetCustomerDetail() {
      var paras = {
        type: 3,
        customerid: this.customerid,
        isall: "all",
        pageIndex: this.pageIndex,
        pageSize: 20,
        name: "all",
        time: this.searchTime.toString()
      };
      getCustomerDetail(paras).then(res => {
        this.diagnoseList = res.DataList;
        console.log(res);
      });
    },
    // 搜索
    EventChangeSearch() {
      this.pageIndex = 1;
      this.APIgetCustomerDetail();
    },
    // 清空
    EventClearSearch() {
      this.searchTime = 1;
      this.pageIndex = 1;
      this.APIgetCustomerDetail();
    },
    // 编辑
    EventChange(row) {
      this.dialogTitle = "编辑信息";
      this.custDiagnose = row;
      this.visible = true;
    },
    // 新增
    EventAdd() {
      this.dialogTitle = "新增信息";
      this.custDiagnose = {
        Id: "",
        CustomerId: this.customerid,
        Type: 3,
        Area: "",
        Address: "",
        Purpose: "",
        Time: "",
        PunchPic: "",
        RecordPic: "",
        ReviewReport: "",
        Approach: "",
        Planning: "",
        Question: "",
        Support: "",
        Proposal: ""
      };
      this.visible = true;
    },
    // 关闭模态窗口
    EventCloseDialog() {
      this.visible = false;
      this.custDiagnose = {};
    },
    // 关闭表单
    eventChangeForm(e) {
      this.custDiagnose = {
        ...this.custDiagnose,
        ...e
      };
    },
    // 提交表单
    EventSubmitForm() {
      var param = this.custDiagnose;
      param.UserId = this.Info.UserCode;
      param.UserName = this.Info.TrueName;
      this.loading = true;
      addCustomerDetail(param)
        .then(() => {
          this.loading = false;
          this.$message({
            message: `${param.Id === "" ? "新增" : "修改"}成功!`,
            type: "success"
          });
          this.EventCloseDialog();
          this.APIgetCustomerDetail();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    // 删除
    delDiagnose(id) {
      this.$confirm("确定删除此条记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          var paras = {
            id: id
          };
          delCustomerDetail(paras).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.searchTime = "";
            this.pageIndex = 1;
            this.APIgetCustomerDetail();
            this.loading = false;
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.searchText {
  float: left;
  line-height: 32px;
  margin-right: 8px;
  font-size: 14px;
}

.demo-table-expand {
  font-size: 0;
  display: flex;
  flex-wrap: wrap;
  padding-left: 60px;
}

.demo-table-expand label {
  width: 130px;
  color: #99a9bf;
  text-align: right !important;
}

.demo-table-expand .el-form-item {
  margin-right: 0 !important;
  margin-bottom: 0;
  width: 50%;
}
</style>
